var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgQuestion = function SvgQuestion(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6 16.945a1.056 1.056 0 0 1 0-2.11 1.056 1.056 0 0 1 0 2.11zm0-3.164c-1.163 0-2.11.946-2.11 2.11C3.89 17.053 4.838 18 6 18c1.163 0 2.11-.947 2.11-2.11 0-1.163-.947-2.109-2.11-2.109z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.867 8.86l-1.812 1.542v1.27h-2.11V9.426l2.556-2.172A2.319 2.319 0 0 0 6 3.164c-1.098 0-2.02.767-2.26 1.793H1.602A4.436 4.436 0 0 1 6 1.055a4.435 4.435 0 0 1 4.43 4.43c0 1.301-.57 2.532-1.563 3.376zM6 0A5.49 5.49 0 0 0 .516 5.484v.528h4.218v-.528a1.267 1.267 0 1 1 2.083.966L3.892 8.939v3.787h4.218V10.89l1.44-1.224a5.477 5.477 0 0 0 1.935-4.18A5.49 5.49 0 0 0 6 0z"
  })));
};

export default SvgQuestion;